import { NgModule, Compiler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Http, HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';

// External Modules
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from './../configuracion/material.module';
import { SessionStorageService } from 'ngx-webstorage';
import { Ng2Webstorage } from 'ngx-webstorage';
import { CookieService } from 'angular2-cookie/services/cookies.service';
import { Logger } from 'angular2-logger/core';

// Libs framework
import { DLogger } from '@dian/core';
import { DLoggerAngular } from '@dian/core';
import { DContextoMuiscaServicio } from '@dian/core';
import { DContextoMuiscaDesaServicio } from '@dian/core';
import { DSessionStorage } from '@dian/core';
import { DFormularioServicio } from '@dian/api-formulario';

// Conf
import { loggerFactory, contextoMuiscaFactory, formularioFactory, sessionStorageFactory } from './../configuracion/app.factories';

//import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
//import { FlexLayoutModule } from '@angular/flex-layout';
//import { Http, HttpModule } from '@angular/http';
//import { HttpClientModule } from '@angular/common/http';

//import { MaterialModule } from './../configuracion/material.module';
import { FooterComponent } from './../components/footer/footer.component';
import { BlockCutCopyPasteDirective } from './../directives/block-cut-copy-paste.directive';
import { DNotificacionServicio, DNotificacionesComponente } from '@dian-cmp/notificaciones';
import { DIdentidadAuthConfigServicios } from '@dian/api-identidad-auth-config';
import { CaptchaCloudflareComponent } from '../components/captcha-cloudflare/captcha-cloudflare.component';
//import { EmailComponent } from './resources/components/modals/email/email.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    HttpModule, 
    FormsModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    //External
    Ng2Webstorage.forRoot({ 
      prefix: 'DIAN', 
      separator: '-', 
      caseSensitive:true 
    }),
    /*HttpModule,
    HttpClientModule,
    Ng2Webstorage.forRoot({ 
      prefix: 'DIAN', 
      separator: '-', 
      caseSensitive:true 
    })*/
  ],
  declarations: [
  	FooterComponent,
  	BlockCutCopyPasteDirective,       
    CaptchaCloudflareComponent
  	//NotificacionesComponente,
    //EmailComponent
  ],
  exports: [
  	//MaterialModule,
  	//FlexLayoutModule,
  	//HttpClientModule,
    MaterialModule,
    FlexLayoutModule,
  	FooterComponent,
    BlockCutCopyPasteDirective,
    CaptchaCloudflareComponent
  ],
  providers: [
  	//DNotificacionServicio
    CookieService, 
    Compiler,
    Logger,
    DNotificacionServicio,
    DIdentidadAuthConfigServicios,
    {
        provide: DLogger,
        useFactory: loggerFactory,
        deps: [Logger]
    },
    {
        provide: DSessionStorage,
        useFactory: sessionStorageFactory,
        deps: [SessionStorageService,DLogger]
    },
    {
        provide: DContextoMuiscaServicio,
        useFactory: contextoMuiscaFactory,
        deps: [Http, CookieService, Compiler, DLogger, DNotificacionServicio, DSessionStorage]
    },
    {
        provide:  DFormularioServicio,
        useFactory: formularioFactory,
        deps: [DContextoMuiscaServicio]            
    }    
  ],
  //entryComponents: [
    //DNotificacionesComponente,
    //EmailComponent     
  //]
})
export class IntegradorModule { }



// WEBPACK FOOTER //
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/resources/modules/integrador.module.ts